import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { hasGeolocation } from '../../reducers/history/utils';
import GeolocationIcon from '../icons/GeolocationIcon';
import { updateScroll } from '../MessageHistory';
import { sendGeolocation } from '../../reducers/history/actions';

const GeolocationWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 0 6px 0;
  flex-shrink: 0;
`;

const GeolocationLozenge = styled.div`
  padding: 5px 10px;
  margin: 0 5px;
  border-radius: 30px;
  min-width: 30px;

  background: ${props => props.theme.accentColor};
  color: white;
  text-align: center;

  cursor: ${props => (props.sending ? 'default' : 'pointer')};

  display: flex;
  align-items: center;
`;

class Geolocation extends Component {
  state = {
    isSending: false
  };
  componentWillReceiveProps(nextProps) {
    if (!nextProps.hasGeolocation && this.props.hasGeolocation && this.state.isSending) {
      this.setState({ isSending: false });
    }
  }
  handleClick = () => {
    this.setState({ isSending: true });
    this.props.sendGeolocation();
    this.props.inputFieldRef.current.focus();
  };

  componentDidUpdate() {
    updateScroll();
  }

  render() {
    const { isSending } = this.state;
    const { hasGeolocation } = this.props;

    if (!hasGeolocation) {
      return null;
    }

    return (
      <GeolocationWrapper>
        <GeolocationLozenge sending={isSending} onClick={isSending ? null : this.handleClick}>
          <GeolocationIcon />
          <div>{isSending ? 'Sending Location...' : 'Send Location'}</div>
        </GeolocationLozenge>
      </GeolocationWrapper>
    );
  }
}

export default connect(
  state => ({
    hasGeolocation: hasGeolocation(state.history.activities),
    inputFieldRef: state.ui.inputFieldRef
  }),
  { sendGeolocation }
)(Geolocation);



// WEBPACK FOOTER //
// ./src/components/Geolocation/index.js